module.exports = __webpack_public_path__ + "img/brands-pan-cocoa.jpg?39a696c008aa0f925cc7b1fb319dc424";